import { render } from "./AssessDashboard.vue?vue&type=template&id=ba96a2fa&scoped=true"
import script from "./AssessDashboard.vue?vue&type=script&lang=js"
export * from "./AssessDashboard.vue?vue&type=script&lang=js"

import "./AssessDashboard.vue?vue&type=style&index=0&id=ba96a2fa&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba96a2fa"]])

export default __exports__